import { es6ModuleBrowserslistRegex } from '../generated/supportedEs6ModuleBrowsersRegex';
import { modernBrowserslistRegex } from '../generated/supportedModernBrowsersRegex';

export enum BrowserSupport {
  MODERN = 'modern',
  ES6_MODULES = 'es6-modules',
  OLD = 'old',
}

/**
 * Get the browser support.
 */
export const getBrowserSupport = () => {
  const isModern = modernBrowserslistRegex.test(navigator.userAgent);

  if (isModern) {
    // eslint-disable-next-line no-console
    console.info('Your browser is modern, nice ✨.');
    return BrowserSupport.MODERN;
  }

  const supportsES6Modules = es6ModuleBrowserslistRegex.test(
    navigator.userAgent
  );

  if (supportsES6Modules) {
    // eslint-disable-next-line no-console
    console.info(
      'Your browser supports ES6 modules, but is not modern enough for our modern build 💀.'
    );
    return BrowserSupport.ES6_MODULES;
  }

  // eslint-disable-next-line no-console
  console.info(
    "Please update your browser 😢. Let's hope that this application still works for you, though."
  );
  return BrowserSupport.OLD;
};
